module.exports = __webpack_public_path__ + "img/54_top.7ad5d9d5.png";